export default {
	ru: {
		noInternet: 'Отсутствует интернет соединение',
	},
};
